import { render, staticRenderFns } from "./SimpleCartIcon.vue?vue&type=template&id=6dcb3a9b"
import script from "./SimpleCartIcon.vue?vue&type=script&lang=js"
export * from "./SimpleCartIcon.vue?vue&type=script&lang=js"
import style0 from "./SimpleCartIcon.vue?vue&type=style&index=0&id=6dcb3a9b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports